module.exports = __webpack_public_path__ + "2f12242375edd68e9013ecfb59c672e9.svg";